// Module
var code = "<div class=\"am-tabs-drv\">\n    <tab ng-repeat=\"tab in tabs\" ng-click=\"select(tab)\" ng-style=\"{width: getTabWidth(tab) + 'px'}\" ng-class=\"{'selected' : isSelected(tab)}\" permissions=\"tab.permissions\">\n        <span class=\"box text\">{{ tab.label }}</span>\n    </tab>\n</div>\n";
// Exports
module.exports = code;